module.exports = __webpack_public_path__ + "img/whatsapp.c2d825bc.svg";